export default "__VITE_ASSET__BUe1CIwm__"